import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";
import { MemberShell } from "@/components/MemberShell";
import { useI18n } from "@/lib/i18n";
import { useMember } from "@/lib/member";
import { api, rp, fmtDate, statusColor } from "@/lib/api";
import { logError } from "@/lib/log";

export default function MemberBookings() {
  const { t, lang } = useI18n();
  const { member, loading } = useMember();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!member) return;
    api.get("/member/bookings").then((r) => setRows(r.data)).catch((e) => logError("Member bookings failed", e));
  }, [member]);

  if (loading) return <SiteLayout><div className="mx-auto max-w-4xl px-5 py-24 text-ink-soft">{t("loading")}</div></SiteLayout>;
  if (!member) return <Navigate to="/member/login" replace />;

  return (
    <MemberShell>
      <h2 className="font-display text-2xl tracking-tight">{t("myBookings")}</h2>
      <div className="mt-5 space-y-3" data-testid="member-bookings">
        {rows.map((b) => (
          <div key={b.booking_code} className="lm-card rounded-xl p-4 flex flex-wrap items-center gap-3"
            data-testid={`member-booking-${b.booking_code}`}>
            <div className="min-w-0 flex-1">
              <div className="font-semibold text-sm">{b.booking_code}</div>
              <div className="text-xs text-ink-soft mt-0.5">
                {fmtDate(b.rental_date, lang)} · {b.start_time} · {b.package_name_snapshot} · {b.quantity} {t("bookingUnit")}
              </div>
            </div>
            <div className="text-sm">{rp(b.total_payment)}</div>
            <span className={`text-[11px] px-2 py-0.5 rounded-full border ${statusColor(b.booking_status)}`}>{t("bookingStatusText")[b.booking_status] || b.booking_status}</span>
          </div>
        ))}
        {rows.length === 0 && (
          <div className="text-sm text-ink-soft" data-testid="member-no-bookings">
            {member.link_status === "pending" ? t("pendingLinkSub") : t("noBookings")}
          </div>
        )}
      </div>
    </MemberShell>
  );
}
